import type { UrlEntry, UrlRegion } from '@/types';

export const urls: Record<'b2b', Record<UrlRegion, UrlEntry>> = {
  b2b: {
    de: 'unternehmen',
    'de-en': 'enterprise',
    es: 'empresas',
    'es-en': 'enterprise',
    fr: 'entreprise',
    'fr-en': 'enterprise',
    gb: 'enterprise',
    nl: 'bedrijven',
    'nl-en': 'enterprise',
    pt: 'empresa',
    'pt-en': 'enterprise',
    us: 'enterprise',
    ww: 'enterprise',
  },
};
